module.exports = __webpack_public_path__ + "static/6@2x-2caccc3d83de7847de3c168e7a35e786.png";